
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule102DataInfoType } from '@/types/Application/FamilyLawMatter/Pdf';
import { disagreeExistingPropertyDivisionOrderDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/CompanionAnimal';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule102 extends Vue {

    @Prop({required:true})
    result!: any; 
   
    dataReady = false;
    exReplyCompInfo = {} as schedule102DataInfoType;
   
    mounted(){
        this.dataReady = false;      
        this.extractInfo();       
        this.dataReady = true;        
    }    

    public extractInfo(){ 
        this.exReplyCompInfo = this.getExReplyCompanionAnimalInfo(); 
    }

    public getExReplyCompanionAnimalInfo(){
       
        let exReplyCompInfo = {} as schedule102DataInfoType;

        exReplyCompInfo = {
            disagreeReason: '',
            replace: false,
            replaceDetails: ''  
        }

        if (this.result.disagreeExistingPropertyDivisionOrderSurvey){
            const exReplyCompData: disagreeExistingPropertyDivisionOrderDataInfoType = this.result.disagreeExistingPropertyDivisionOrderSurvey;
            
            exReplyCompInfo.disagreeReason = exReplyCompData.disagreeExistingCompanionAnimalOrder?exReplyCompData.disagreeExistingCompanionAnimalOrder:''//exCompData.setAsideReason;
            exReplyCompInfo.replace = exReplyCompData.existingOrderContinue == 'n';         
            if (exReplyCompInfo.replace){
                exReplyCompInfo.replaceDetails = exReplyCompData.replaceExistingAgreementChanges?exReplyCompData.replaceExistingAgreementChanges:'';
            }
        }

       return exReplyCompInfo;
   } 

}
